import React from 'react';
import { bankFeedTypeDetails } from './BankFeedInfo';
import css from './bfm.css';

const SelectBankFeedType = ({ selectedType, onSelectionChanged, region }) => {
  const feedTypes = ['Direct feed', 'Yodlee'];
  if (region === 'AU') feedTypes.unshift('Open Banking');

    return (
      <div style={{ padding: '15px 0 25px 0' }}>
        <div className={css.addFeedHeader}>Select bank feed type</div>
        <div className={css.feedTypeSelector}>
        {feedTypes.map(type => (
        <div
          key={type}
          className={selectedType === type ? css.feedTypeButtonSelected : undefined}
          onClick={() => onSelectionChanged(type)}
          >
          {type}
        </div>
      ))}
        </div>
        <div className={css.feedTypeDetails}>
          {bankFeedTypeDetails[selectedType.replace(' ', '')]} &nbsp;
          <a className={css.learnMore} href="https://help.reckon.com/article/sl3ygs4fre-creating-and-managing-bank-feeds" target="_blank">Learn more</a>
        </div>
      </div>
     );
};

export default SelectBankFeedType;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/SelectBankFeedType.js